import React from "react";

import SingleCardSlider from "../single-card-slider";

import "./single-big-card-slider.m.css";

const SingleBigCardSlider = ({ collection }) => {
  return (
    <div styleName="big-card-slider">
      <SingleCardSlider collection={collection} bigSlider />
    </div>
  );
};

export default SingleBigCardSlider;
